<div *ngFor="let project of projectsList; let i = index" class="project-list py-3 cursor-pointer"
[ngClass]="{'separator-item': i != 0}">

  <div [@floatTop]="{ value: '', params: {delay: i * 50}}" >
    <kl-project-list-item [project]="project"></kl-project-list-item>
  </div>

</div>
